export default __webpack_public_path__ + "static/media/Products.04300c4c.png";